
const newModel = () => {
    return {
        thethaoHangcanId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        thethaoHangcanId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        thethaoHangcanId: item.thethaoHangcanId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocEnabledDisplay: item.iocEnabled == 1 ? true : false,
        iocDateUpdated: item.iocDateUpdated,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        thethaoHangcanId: item.thethaoHangcanId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        iocId: item.iocId,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        thethaoHangcanId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        enabled: null,
    }

}
const errors = () => {
    return {
        thethaoHangcanId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const hangCanTheThaoVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    fromJson,
    errors,
}


